import { Toast } from "primereact/toast";
import { useSession } from "../assets/auth/SessionContext";
import { useEffect, useRef, useState } from "react";
import { postData, putData } from "../services/api";
import { InputSwitch } from "primereact/inputswitch";

export default function RoleModal(modalData: any) {

    const [formData, setFormData] = useState(modalData.selectedDataItem);
    const [abbreviationEditable, setAbbreviationEditable] = useState(false);
    const [modalHeader, setModalHeader] = useState("");
    const [isUi, setIsUi] = useState(false);
    const [isDevice, setIsDevice] = useState(false);
    const [saveDisabled, setSaveDisabled] = useState(false);

    const toast = useRef<Toast>(null);

    const { session } = useSession();

    function save(data: any) {
        try {

            if (!data.ref) {
                throw new Error("Abbreviation is required")
            }

            if (!data.name) {
                throw new Error("Name is required")
            }

            if (!data.level) {
                throw new Error("Level is required")
            }

            if (isUi === false && isDevice === false) {
                throw new Error("Either UI or device must be selected")
            }

            if (isUi && isDevice) {
                throw new Error("Either UI or device must be selected")
            }

            let role = {
                ref: data.ref,
                name: data.name,
                description: data.description,
                level: parseInt(data.level),
                isUi: isUi,
                isDevice: isDevice
            } as any;


            if (modalData.mode === "update") {
                putData(session, `roles/${role.ref}`, role, null).then(updateRoleData => {

                    modalData.closeModal({ toast: true, message: `${role.name} updated`, updateRecord: role });

                    if (toast.current) {
                        toast.current.show({ severity: 'success', summary: 'Role created', detail: "" });
                    }

                    setSaveDisabled(false);
                    return;

                }).catch(err => {
                    if (toast.current) {
                        toast.current.show({ severity: 'error', summary: 'Error Message', detail: err.message });
                    }

                    setSaveDisabled(false);
                });
            } else if (modalData.mode === "create") {

                postData(session, `roles`, role, null).then(newRoleData => {

                    modalData.closeModal({ toast: true, message: `${role.name} created`, newRecord: newRoleData });

                    if (toast.current) {
                        toast.current.show({ severity: 'success', summary: 'Role created', detail: "" });
                    }

                    setSaveDisabled(false);
                    return;

                }).catch(err => {
                    if (toast.current) {
                        toast.current.show({ severity: 'error', summary: 'Error Message', detail: err.message });
                    }

                    setSaveDisabled(false);
                });
            }
        } catch (error: any) {
            if (toast.current) {
                toast.current.show({ severity: 'error', summary: 'Error Message', detail: error.message });
            }

            setSaveDisabled(false);
        }
    }

    useEffect(() => {
        if (modalData.mode === "create") {
            setAbbreviationEditable(true)
            setModalHeader("Creating Role")
        } else {
            setAbbreviationEditable(false)
            setModalHeader("Updating Role")
        }

        setIsUi(formData.isUi);
        setIsDevice(formData.isDevice);

    }, []);

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setFormData((prevFormData: any) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    return (
        <div className="modal-container">

            <Toast ref={toast} />
            <div className="modal ">
                <div className="modal-header">
                    <span className="modal-title">{modalHeader}</span>
                    <span className="modal-close" onClick={modalData.closeModal}>&times;</span>
                </div>

                <div className="flex">
                    <div className="flex-1 flex m-2 px-5 py-3 ">
                        <label className="text-label" htmlFor="ref">Abbreviation</label>
                        <input
                            className="text-input"
                            readOnly={!abbreviationEditable}
                            type="text"
                            id="ref"
                            name="ref"
                            value={formData.ref}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="flex-1 flex m-2 px-5 py-3">
                        <label className="text-label" htmlFor="name">Name</label>
                        <input
                            className="text-input"
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="flex-1 flex m-2 px-5 py-3 ">
                        <label className="text-label" htmlFor="level">Level</label>
                        <input
                            className="text-input-number"
                            type="number"
                            id="level"
                            name="level"
                            value={formData.level}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="flex">
                    <div className="flex-1 flex m-2 px-5 py-3">
                        <label className="text-label" htmlFor="description">Description</label>
                        <textarea
                            className="text-input-multiline"
                            id="description"
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="flex-1 flex m-2 px-5 py-3 ">
                        <label className="text-label" htmlFor="isUi">UI</label>
                        <div className="input-switch-min-width">
                            <InputSwitch
                                checked={isUi}
                                onChange={(e) => setIsUi(e.value)}
                            />
                        </div>
                    </div>
                    <div className="flex-1 flex m-2 px-5 py-3 ">
                        <label className="text-label" htmlFor="isDevice">Device</label>
                        <div className="input-switch-min-width">
                            <InputSwitch
                                checked={isDevice}
                                onChange={(e) => setIsDevice(e.value)}
                            />
                        </div>
                    </div>
                </div>

                <div className="footer">
                    <button disabled={saveDisabled} className="save-button" type="button" onClick={() => {
                        setSaveDisabled(true);
                        save(formData);
                    }
                    }>Save</button>
                    <button type="button" className="cancel-button" onClick={modalData.closeModal}>Cancel</button>
                </div>
            </div>
        </div >
    );
}